export default __webpack_public_path__ + "book_details-edition.c81ad079.png";